/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import labelsJson from './_labels.json';

export const labels = labelsJson.en;
export const Labels = labels;
